import { render } from "./SVGIcon.vue?vue&type=template&id=69634362"
import script from "./SVGIcon.vue?vue&type=script&lang=js"
export * from "./SVGIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__